// Deferred script — DOM is ready at execution time

(function () {

  // ── Nav scroll hide/show ────────────────────────────────────────────────────
  var nav = document.querySelector('.op-nav');
  if (nav) {
    var lastScroll = 0;
    var ticking    = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var currentScroll = window.scrollY;
          if (currentScroll > 200) {
            nav.classList.toggle('op-nav--hidden', currentScroll > lastScroll);
          } else {
            nav.classList.remove('op-nav--hidden');
          }
          lastScroll = currentScroll;
          ticking    = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Lazy images ──────────────────────────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var lazyImages   = document.querySelectorAll('img[data-src]');
    var imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px 0px' });

    lazyImages.forEach(function (img) { imageObserver.observe(img); });
  }

  // ── GSAP scroll animations ───────────────────────────────────────────────────
  try {
    if (typeof gsap === 'undefined') return;

    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    gsap.utils.toArray('[data-animate="fade-up"]').forEach(function (el) {
      var delay = parseFloat(el.dataset.delay || 0);
      gsap.fromTo(el,
        { opacity: 0, y: 36 },
        {
          opacity: 1, y: 0,
          duration: 0.9,
          delay: delay,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        }
      );
    });

    gsap.utils.toArray('[data-animate="stagger"]').forEach(function (parent) {
      var children = Array.from(parent.children);
      if (!children.length) return;
      gsap.fromTo(children,
        { opacity: 0, y: 28 },
        {
          opacity: 1, y: 0,
          duration: 0.75,
          stagger: 0.11,
          ease: 'power3.out',
          scrollTrigger: { trigger: parent, start: 'top 85%', once: true }
        }
      );
    });

    gsap.utils.toArray('[data-animate="fade-in"]').forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 1.1,
          ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 90%', once: true }
        }
      );
    });

  } catch (e) {
    console.warn('Omnipole GSAP init:', e);
  }

})();
